import AbdomenForm from './Abdomen'
import BackForm from './Back'
import CardiovascularForm from './Cv'
import ExtremitiesForm from './Extremities'
import EyesForm from './Eyes'
import GeneralForm from './General'
import GenitourinaryForm from './Genitourinary'
import HeadForm from './Head'
import IntegumentaryForm from './Integumentary'
import NeckForm from './Neck'
import NeurologicalForm from './Neuro'
import MentalHealthForm from './Psychiatric'
import RespiratoryForm from './Respiratory'

export { GeneralForm }
export { HeadForm }
export { EyesForm }
export { NeckForm }
export { RespiratoryForm }
export { CardiovascularForm }
export { AbdomenForm }
export { BackForm }
export { GenitourinaryForm }
export { ExtremitiesForm }
export { NeurologicalForm }
export { IntegumentaryForm }
export { MentalHealthForm }

export default {
  GeneralForm,
  HeadForm,
  EyesForm,
  NeckForm,
  RespiratoryForm,
  CardiovascularForm,
  AbdomenForm,
  BackForm,
  GenitourinaryForm,
  ExtremitiesForm,
  NeurologicalForm,
  IntegumentaryForm,
  MentalHealthForm
}
